export default __webpack_public_path__ + "../img/889be2ee28570cd46f61792ad5bff7bb.png";